<template>
  <main class="p20 bg-white main stock">
    <div class="mt20 mb20">
      <span class="title1">库存</span>
      <router-link to='/zhongzhuanbuhuo/wait/out' class="btn-pending ivu-btn ivu-btn-primary fr ml20">待出库区
        <span>{{pending_count}}</span>
      </router-link>
      <!--      <router-link to='/Warehouse/SKU/Import' class="btn-pending ivu-btn ivu-btn-primary fr ml20">导入SKU信息</router-link> -->
    </div>
    <div class="clear-fix"></div>
    <div class="search-one mt20">
      <div class="search-item">
        入库包裹号
        <Input class='ml10 mr20 w200' v-model="screen_data.in_bill_no" placeholder="请输入入库包裹号" />
      </div>
      <div class="search-item">
        快递单号
        <Input class='ml10 mr20 w200' v-model="screen_data.waybill_code" placeholder="请输入快递单号" />
      </div>
      <div class="search-item">
        SKU
        <Input class='ml10 mr20 w200' v-model="screen_data.sku" placeholder="请输入快递单号" />
      </div>
      <div class="search-item">
        商品名称
        <Input class='ml10 mr20 w200' v-model="screen_data.product_name" placeholder="请输入快递单号" />
      </div>
      <div class="search-item">
        状态
        <Select v-model="screen_data.out_status" class='ml10 mr20' style="width: 120px;">
          <Option v-for="(option, index) in statusList" :value="option.value" :key="index">{{option.label}}</Option>
        </Select>
      </div>
      <div class="search-item">
        入库时间
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
      </div>
      <div class="search-item">
        <!-- <button v-if="active==1" class="ivu-btn ivu-btn-primary fr ml20" @click="exportData">导出</button> -->
        <button v-if="active==1" class="ivu-btn ivu-btn-primary fr ml20" @click="batchAddToPendingOut">批量加入待出库区</button>
        <button class="ivu-btn ivu-btn-primary fr" @click="search">搜索</button>
      </div>
    </div>
    <div class="mt20 pb20">
      <Table ref="data_list" stripe :loading="loading" border :columns="table_data.columns" :data="table_data.data">
        <template slot-scope="{ row, index }" slot="change">
          <span v-if="row.change_price > 0" style="color: #4acd40;">
            <Icon type="md-arrow-round-up" />{{row.change_rate_2}}%
          </span>
          <span v-if="row.change_price == 0">
            {{row.change_rate_2}}%
          </span>
          <span v-if="row.change_price <0" style="color: #ff0001;">
            <Icon type="md-arrow-round-down" />{{row.change_rate_2}}%
          </span>
        </template>
        <template slot-scope="{ row, index }" slot="change_price">
          <span v-if="row.change_price > 0" style="color: #4acd40;">
            <Icon type="md-arrow-round-up" />{{row.change_price}}
          </span>
          <span v-if="row.change_price == 0">
            {{row.change_price}}
          </span>
          <span v-if="row.change_price <0" style="color: #ff0001;">
            <Icon type="md-arrow-round-down" />{{row.change_price}}
          </span>
        </template>
        <template slot-scope="{ row, index }" slot="images">
          <span class="item-img mr10 fl" v-for="(v,i) in row.image_arr" :key="i" :src="v">
            <el-image style="width: 30px; height: 30px;margin-top: 10px;" :src="v" :preview-src-list="row.image_arr">
            </el-image>
          </span>
        </template>
      </Table>
    </div>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>

    <Modal :title="'入库单号为'+detailInfo.in_bill_no+'的详情'" v-model="show_detail" width="800">
      <div class="details f14">
        <p class="mt10">快递单号 {{detailInfo.waybill}}</p>
        <p class="mt10">客户编号 {{detailInfo.client_code}}</p>
        <p class="mt10">客户姓名 {{detailInfo.client_name}}</p>
      </div>
      <Table class="mt20" border :columns="detail_columns" :data="detail_list">
      </Table>
      <div slot="footer"></div>
    </Modal>

  </main>
</template>

<script>
  import Paging from '@/components/common/paging'
  export default {
    components: {
      Paging
    },
    data() {
      return {
        pending_count: 0,
        detail_list: [],
        detailInfo: {},
        show_detail: false,
        edit_sku_info: [],
        active: 1,
        statusList: [{
          value: '',
          label: '全部'
        }, {
          value: 0,
          label: '在库'
        }, {
          value: 1,
          label: '已加入发货区'
        }, {
          value: 2,
          label: '已提交出库'
        }, {
          value: 3,
          label: '已出库'
        }, {
          value: -2,
          label: '已提交废弃'
        }, {
          value: -3,
          label: '已废弃'
        }],
        table_data: { //列表数据
          columns: [],
          data: []
        },
        category: [],
        website: [],
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          warehouse_id: '',
          client_code: '',
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        detail_columns: [{
          title: 'SKU',
          key: 'sku',
          width: 200,
        }, {
          title: '商品名称',
          key: 'product_name',
          width: 400,
        }, {
          title: '入库数量',
          key: 'instock_count',
          width: 200,
        }]
      }
    },
    methods: {
      init() {
        this.table_data.columns = this.setColumns();
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList(this.active);
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList(this.active);
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList(this.active);
      },
      changeTab(type) {
        this.active = type;
        this.screen_data.pageNum = this.page_data.pageIndex = 1;
        this.getList(this.active);
      },
      /*
       * 获取列表  type : 1是按sku,2是按包裹号
       */
      getList(type) {
        this.$axios.get("/warehouse/in/bill/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data) {
            this.table_data.data = res.data;
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })

      },
      exportData() {
        this.$axios.get("/WarehouseStock/excel/export/sku/downloadcenter", {
          params: this.screen_data
        }).then(res => {
          if (res.success) {
            this.$Message.info('下载成功，请到下载中心中查看~');
          }
        })
      },
      getDetail(in_bill_no) {
        this.$axios.get("/warehouse/in/bill/detail", {
          params: {
            in_bill_no: in_bill_no
          }
        }).then(res => {
          if (res.success && res.data && res.data.length) {
            this.detail_list = res.data;
          }
          this.show_detail = true;
        })
      },
      setColumns(type) {
        let arr = [];
        arr = [{
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        }, {
          title: 'SKU',
          key: 'sku',
          width: 200,
          align: 'center',
          fixed: 'left'
        }, {
          title: '入库单号',
          key: 'in_bill_no',
          tooltip: true,
          width: 180,
          fixed: 'left'
        }, {
          title: '快递单号/物流单号',
          key: 'waybill',
          tooltip: true,
          width: 180,
        }, {
          title: '商品名称',
          key: 'product_name',
          width: 300,
        }, {
          title: '数量',
          key: 'product_count',
          width: 100,
          render: (h, params) => {
            if (params.row.product_count == 0) {
              return h("span", "-");
            } else {
              return h("span", params.row.product_count);
            }
          }
        }, {
          title: '入库时间',
          key: 'create_date',
          width: 185,
        }, {
          title: '状态',
          key: 'out_status',
          width: 185,
          render: (h, params) => {
            let showText = "";
            switch (params.row.out_status) {
              case -3:
                showText = "已废弃";
                break;
              case -2:
                showText = "已提交废弃";
                break;
              case 0:
                showText = "在库";
                if (params.row.product_count == 0) {
                  showText += "待补全";
                }
                break;
              case 1:
                showText = "已加入发货区";
                break;
              case 2:
                showText = "已提交出库";
                break;
              case 3:
                showText = "已出库";
                break;
            }

            return h("span", showText);
          }
        }, {
          title: '客户编号',
          key: 'client_code',
          tooltip: true,
          width: 100,
        }, {
          title: '客户姓名',
          key: 'client_name',
          tooltip: true,
          width: 200,
        }, {
          title: '操作',
          minWidth: 240,
          fixed: 'right',
          render: (h, params) => {
            let doms = [];
            doms.push(h('span', {
              style: {
                cursor: "pointer",
                color: "#0062da"
              },
              on: {
                click: () => {
                  this.detailInfo = params.row;
                  this.getDetail(params.row.in_bill_no, 1)
                }
              }
            }, '查看详情'));

            if (params.row.out_status == 0 && params.row.product_count > 0) {
              doms.push(h('span', {
                style: {
                  cursor: "pointer",
                  color: "#0062da"
                },
                on: {
                  click: () => {
                    this.addPending(params.row.in_bill_no)
                  }
                }
              }, ' 添加待出库区 '));
            }

            if (params.row.out_status == 1 && params.row.product_count > 0) {
              doms.push(h('span', {
                style: {
                  cursor: "pointer",
                  color: "#0062da"
                },
                on: {
                  click: () => {
                    this.removePending(params.row.in_bill_no)
                  }
                }
              }, ' 移出待出库区 '));
            }



            return h("div", doms);
          }
        }];
        return arr;
      },
      addPending(in_bill_no) { //添加到出库区

        // if (this.screen_data.client_code == undefined || this.screen_data.client_code == '') {
        //   this.$Message.error('请先在上方选择 子账户！');
        //   return;
        // }
        this.$axios.put('/warehouse/in/out/pending', this.$qs.stringify({
          in_bill_no: in_bill_no
        })).then((data) => {
          if (data.success) {
            this.$Message.success('添加成功');
            this.getList()
            this.getPendingCount()
          }
        })
      },

      batchAddToPendingOut() {
        let items = this.$refs.data_list.getSelection();
        if (items.length == 0) {
          this.$Message.error('请选择要批量操作的包裹');
          return;
        }

        let bill_nos = "";

        items.forEach(function(item) {
          if (item.out_status == 0) {
            // that.payDirectly(that, item);
            bill_nos += (item.in_bill_no + ",");
          }
        });

        //发起请求
        this.$axios.put('/warehouse/in/out/pending/batch', this.$qs.stringify({
          in_bill_nos: bill_nos
        })).then((data) => {
          if (data.success) {
            this.$Message.success('添加成功');
            this.getList()
            this.getPendingCount()
          }
        })

      },

      removePending(in_bill_no) { //添加到出库区

        // if (this.screen_data.client_code == undefined || this.screen_data.client_code == '') {
        //   this.$Message.error('请先在上方选择 子账户！');
        //   return;
        // }
        this.$axios.delete('/warehouse/in/out/pending', {
          params: {
            in_bill_no: in_bill_no
          }
        }).then((data) => {
          if (data.success) {
            this.$Message.success('移出成功');
            this.getList()
            this.getPendingCount()
          }
        })
      },

      getPendingCount() { //待出库区数量
        if (!this.screen_data.client_code) {
          return false;
        }
        this.$axios.get("/warehouse/in/out/pending/count", {
          params: this.screen_data
        }).then(res => {
          if (res.success) {
            this.pending_count = res.data;
          }
        })
      },
      editSKUInfo(data) { //编辑SKU信息

        this.edit_sku_info = data;
        this.show_detail = true;

      },
      updateSKUInfo() {


        this.$axios.post("/WarehouseStock/sku/info", this.$qs.stringify(this.edit_sku_info)).then(res => {
          if (res.success) {
            this.$Message.success("更新成功");
            this.show_detail = false;
            this.getList(this.active);
          }
        });
      },
      cancelSKUInfo() {
        this.show_detail = false;
      }
    },
    created() {
      this.init();
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id') || '';
      this.screen_data.client_code = localStorage.getItem('client_code') || '';
      this.screen_data.biz_type = 0;
      if (this.screen_data.warehouse_id) {
        this.getList();
        this.getPendingCount()
      } else {
        this.$Message.info('请选择仓库')
      }

    }
  }
</script>

<style>
  .stock .w200 {
    width: 200px !important;
  }

  .tab-tr {
    float: right;
  }

  .tab-tr span {
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #4f6081;
    text-align: center;
    float: left;
    cursor: pointer;
  }

  .tab-tr span.active {
    background-color: #4f6081;
    color: #fff;
  }

  .btn-pending {
    line-height: 40px !important;
    margin-top: 40px;
    color: #FFFFFF !important;
    position: relative;
  }

  .btn-pending span {
    display: inline-block;
    background-color: red;
    color: #FFFFFF;
    position: absolute;
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    text-align: center;
    padding: 0;
    top: -10px;
    right: -10px;
    font-size: 13px;
  }
</style>
<style lang="scss">
  .new-account {
    .label {
      display: inline-block;
      width: 100px;
      text-align: right;
      margin-right: 10px;
    }

    .list {
      height: 50px;
      line-height: 50px;
      // margin-bottom: 5px;
    }
  }

  .account {
    .account-box {
      margin: 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/zhongzhuanbuhuo/stock/list.vue